import Axios from '@/utils/axios';
import Api from '@/constant/api';

export const getCategory = async (params) => {
  return Axios.jsonGet(Api.goods.category, { params });
};

export const getSkuList = async (params) => {
  return Axios.jsonGet(Api.goods.sku_list, { params });
};

export const applySku = async (params) => {
  return Axios.jsonPost(Api.goods.apply_sku, params);
};

export const getSkuDetail = async (params) => {
  return Axios.jsonGet(Api.goods.sku_draft_info, { params });
};

export const approvalSku = async (params) => {
  return Axios.jsonPost(Api.goods.approval_sku, params);
};

export const releaseSku = async (params) => {
  return Axios.jsonPost(Api.goods.release_sku, params);
};

export const shelfSku = async (params) => {
  return Axios.jsonPost(Api.goods.shelf_sku, params);
};

export const delSku = async (params) => {
  return Axios.jsonPost(Api.goods.del_sku, params);
};

export const getSupplierSkuList = async (params) => {
  return Axios.jsonGet(Api.goods.supplier_sku_list, { params });
};

export const getSkuComments = async (params) => {
  return Axios.jsonGet(Api.goods.comments, { params });
};
